export function fetchingClubs() {
  return {
    type: 'FETCHING_CLUBS',
  };
}

export function fetchClubsSuccess(data) {
  return {
    type: 'FETCH_CLUBS_SUCCESS',
    data
  };
}

export function fetchClubsFailure() {
  return {
    type: 'FETCH_CLUBS_FAILED'
  };
}

export function clearClubs() {
  return {
    type: 'CLEAR_CLUBS'
  };
}



// WEBPACK FOOTER //
// ./src/club/SelectClubActions.jsx